import type { SessionSummary } from '@/app/app/research-assistant/types';

export const RESEARCH_SESSION_LIST_UPDATED_EVENT = 'attune:research-session-list-updated';

export type ResearchSessionListChange =
  | {
      type: 'replace';
      projectId: string | null;
      sessions: SessionSummary[];
      hasMore?: boolean;
    }
  | {
      type: 'upsert';
      projectId: string | null;
      session: SessionSummary;
      hasMore?: boolean;
    }
  | {
      type: 'remove';
      projectId: string | null;
      sessionId: string;
      hasMore?: boolean;
    }
  | {
      type: 'refresh';
      projectId: string | null;
    };

export function notifyResearchSessionListChanged(detail: ResearchSessionListChange): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(RESEARCH_SESSION_LIST_UPDATED_EVENT, { detail }));
}

export function subscribeResearchSessionListChanged(
  listener: (detail: ResearchSessionListChange) => void
): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const handleEvent = (event: Event) => {
    listener((event as CustomEvent<ResearchSessionListChange>).detail);
  };

  window.addEventListener(RESEARCH_SESSION_LIST_UPDATED_EVENT, handleEvent);
  return () => window.removeEventListener(RESEARCH_SESSION_LIST_UPDATED_EVENT, handleEvent);
}
